import React from "react";
import {
  CompanyNameFormContent,
  CompanyNameInfoContent,
} from "Components/CompanyPage";
import FormContentWrapper from "Components/FormContentWrapper";
import { useFormData } from "Contexts/FormDataContext";
import { useSession } from "Contexts/SessionContext";
import usePageContextUpdate from "Hooks/usePageContextUpdate";
import { updateContact } from "Lib/session-utils";
import { getPageNumber } from "Data";

const CompanyNamePage = () => {
  const { currentPageData, setSubmitted } = usePageContextUpdate();

  const {
    updateCompanyInfo,
    currentFormData: { companyName, industry },
  } = useFormData();

  const { updateSession, sessionData, contactId } = useSession();

  const handleSubmit = async (data) => {
    updateCompanyInfo(data.companyName, data.industry);

    if (contactId) {
      await updateContact(contactId, {
        company: data.companyName,
        industry: data.industry,
      });
    }

    await updateSession({
      current_page: getPageNumber("company-size"),
      responses: {
        ...sessionData?.responses,
        q2_company_info: {
          company: data.companyName,
          industry: data.industry,
        },
      },
    });

    setSubmitted(true);
  };

  return (
    <>
      <FormContentWrapper
        infoContent={
          <CompanyNameInfoContent heading={currentPageData.pageTitle} />
        }
        formFieldContent={
          <CompanyNameFormContent
            submitCB={handleSubmit}
            companyName={companyName}
            industry={industry}
          />
        }
      />
    </>
  );
};

export default CompanyNamePage;
